import React from 'react';
import {
  Snackbar,
  Alert,
  Slide
} from '@mui/material';
import { useApp } from '../../context/AppContext';

function SlideTransition(props) {
  return <Slide {...props} direction="up" />;
}

const SnackbarNotification = () => {
  const { state, actions } = useApp();

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    actions.hideSnackbar();
  };

  return (
    <Snackbar
      open={state.snackbar.open}
      autoHideDuration={6000}
      onClose={handleClose}
      TransitionComponent={SlideTransition}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
    >
      <Alert 
        onClose={handleClose} 
        severity={state.snackbar.severity}
        variant="filled"
        sx={{ width: '100%' }}
      >
        {state.snackbar.message}
      </Alert>
    </Snackbar>
  );
};

export default SnackbarNotification; 